import { render, staticRenderFns } from "./ConsentPage.vue?vue&type=template&id=4dc9f8cc&scoped=true&"
import script from "./ConsentPage.vue?vue&type=script&lang=js&"
export * from "./ConsentPage.vue?vue&type=script&lang=js&"
import style0 from "./ConsentPage.vue?vue&type=style&index=0&id=4dc9f8cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc9f8cc",
  null
  
)

export default component.exports